import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useUnitsSelector = () => useSelector((state: StateExtended) => state.units.units);
